export interface JsonPatchOp {
    op: "replace" | "add" | "remove";
    path: string;
    value?: unknown;
}

/**
 * Converts react-hook-form's `dirtyFields` boolean tree and the current form `values`
 * into an array of JSON Patch replace operations.
 *
 * Handles nested objects: { candidateCustomFields: { customField01: true } }
 * → [{ op: "replace", path: "/candidateCustomFields/customField01", value: "DEN" }]
 */
export function buildJsonPatch(dirtyFields: Record<string, unknown>, values: Record<string, unknown>, prefix = ""): JsonPatchOp[] {
    const ops: JsonPatchOp[] = [];

    for (const key of Object.keys(dirtyFields)) {
        const dirty = dirtyFields[key];
        const value = (values as Record<string, unknown>)[key];
        const path = `${prefix}/${key}`;

        if (dirty === true) {
            ops.push({ op: "replace", path, value: value ?? null });
        } else if (dirty && typeof dirty === "object" && !Array.isArray(dirty)) {
            ops.push(...buildJsonPatch(dirty as Record<string, unknown>, (value as Record<string, unknown>) ?? {}, path));
        }
    }

    return ops;
}
